import React from 'react';
import { styled } from '@compiled/react';
import Tag from '@atlaskit/tag';
import TagGroup from '@atlaskit/tag-group';
import { token } from '@atlaskit/tokens';
import type { CmdbObjectAttributeGroup } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/attribute.tsx';

export type Props = {
	attribute: CmdbObjectAttributeGroup;
};

export const GroupAttribute = (props: Props): React.JSX.Element => {
	const { attribute } = props;

	return (
		<Wrapper>
			<TagGroup>
				{attribute.objectAttributeValues.map(({ group: { name } }, index) => (
					<Tag
						testId="servicedesk-insight-attribute-list.ui.group-attribute.value"
						key={index} // TODO: use group id as the key once we move away from group name
						text={name}
						isRemovable={false}
					/>
				))}
			</TagGroup>
		</Wrapper>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div({
	marginTop: 0,
	marginRight: token('space.negative.050'),
	marginBottom: 0,
	marginLeft: token('space.negative.050'),
});
